import { useProgress } from "common/hooks";
import { Spinner } from "components/Spinner";
import { FormEvent, FunctionComponent } from "react";

interface ButtonProps {
  onClick: (e?: FormEvent) => void;
  children: string;
  disabled?: boolean;
  variant?: "primary" | "alert";
  size?: "xs" | "md";
}

export const Button: FunctionComponent<ButtonProps> = ({
  onClick,
  children,
  disabled,
  variant: style = "primary",
  size,
}) => {
  const { isLoading } = useProgress();
  const variantClass =
    style === "primary"
      ? "bg-blue-600 hover:bg-blue-700 active:bg-blue-800"
      : "bg-red-500 hover:bg-red-600 active:bg-red-700";

  const sizeClass = size === "xs" ? "py-2 text-xs" : "py-2.5 text-sm";

  return (
    <button
      className={`w-full rounded-lg font-medium text-white transition-colors disabled:cursor-not-allowed disabled:bg-gray-200 disabled:text-gray-400 ${variantClass} ${sizeClass}`}
      onClick={!disabled ? onClick : undefined}
      disabled={disabled || isLoading}
    >
      {isLoading ? <Spinner size="sm" /> : children}
    </button>
  );
};
